/** 管理 HTML 元素上的 library-style 屬性 */
export function useLibraryStyle() {
  /** 使用 library-style 屬性 */
  const addLibraryStyle = () => {
    document.querySelector('html')?.setAttribute('library-style', '')
  }

  /** 移除 library-style 屬性 */
  const removeLibraryStyle = () => {
    document.querySelector('html')?.removeAttribute('library-style')
  }

  /** 使用 no-library-style 屬性 */
  const addNoLibraryStyle = () => {
    document.querySelector('html')?.setAttribute('no-library-style', '')
  }

  /** 移除 no-library-style 屬性 */
  const removeNoLibraryStyle = () => {
    document.querySelector('html')?.removeAttribute('no-library-style')
  }

  return {
    /** 使用 library-style 屬性 */
    addLibraryStyle,
    /** 使用 no-library-style 屬性 */
    addNoLibraryStyle,
    /** 移除 library-style 屬性 */
    removeLibraryStyle,
    /** 移除 no-library-style 屬性 */
    removeNoLibraryStyle
  }
}
